// extracted by mini-css-extract-plugin
module.exports = {"container":"SportWidgetList_container__2KZ0h","item":"SportWidgetList_item__lXJ1V","link":"SportWidgetList_link__lgJsn","icon":"SportWidgetList_icon__Slyls"};